import React, {useState, useEffect, Fragment} from "react";
import CommentDialog from "../../../components/CommentsPopUp";
import {Avatar, Comment, Form, Input} from "antd";
import {getCommentsIpsDT , addnewCommentIpsDT} from "../../../api";
import styled from "styled-components";
import { isIPSExternalContributorOrExternalView} from "../../../utils/UserInfo";
import {projectStatusCodeMap} from "../../../components/ProjectStatusCodeMap";
import { UserOutlined } from '@ant-design/icons';

const {TextArea} = Input;
const btnstyle = {
    float: "right",
    color: "white",
    backgroundColor: "#0CA0DA",
    marginTop: "-15px",
    marginRight: "15px",
    paddingTop: "0px",
    paddingBottom: "0px",
};
const commentsStyle = {
    display: "block",
    margin: "15px",
};
const commentcss = {
    marginLeft: "50px",
    marginTop: "-30px",
};
const CommentContainer = styled.div`
    overflow-y : scroll;
    overflow-x: hidden;
    height : 200px;
    max-width: 800px;
    padding-left: 0px;
    font-size:12px;
`;


const Editor = ({onChange, addComment, disable, value,project, ...props}) => (
    <div>
        {
        !isIPSExternalContributorOrExternalView() &&
        <Form.Item>
            <TextArea id="txt" value={value} className="col-xs-12 col-md-4" rows={2} onChange={onChange} maxLength={600}
                      style={{maxWidth: "98%"}} placeholder="Add comments "/>
        </Form.Item>
        }
        {
        !isIPSExternalContributorOrExternalView() &&
        <Form.Item>
            <button id="btSubmit" style={btnstyle}  onClick={addComment}
                    disabled={disable}>
                Post
            </button>
        </Form.Item>
        }

    </div>
);

export default (function IpsDTCommentsDialog(props) {
    const {  onClose, project, commentGroup, commentsList, setCommentsList ,phase } = props;
    const {bpid} = project
    const [value, setValue] = useState('');
    const [comments, setComments] = useState(commentsList);
    const [disable, setDisable] = useState(true);

    

   

    async function addComment(event) {
        let commentRequest = {
        bpid: project.bpid,
        workOrder: project.workOrder,
        stationName: project.stationName,
        commentGrp : commentGroup,
            comments: value,
            phase:phase
    }
        
    let updatedComment = await addnewCommentIpsDT(commentRequest, bpid);
        setValue('');
        setDisable(true);
       
        setComments(updatedComment);
        setCommentsList(updatedComment)
        
    }

    const handleChange = event => {
        setValue(event.target.value);
        setDisable(false);
    };

    return (
        <Fragment>
            <div>
                <CommentDialog onClose={onClose} />
               
                <div>
                    <Comment
                        content={
                            <Editor
                                disable={disable}
                                addComment={addComment}
                                onChange={handleChange}
                                value={value}
                                props={props}
                                project={props.project}
                            />
                        }
                    />
                </div>
                <CommentContainer>
                    {
                        comments.map((user,index) => (
                            <div style={commentsStyle} key={index}>
                                <Avatar size="small" icon={<UserOutlined />}/>
                                <div style={commentcss}>
                                    <span> {user.createdUser} </span>
                                    {/* <span> {user.lastName} </span> */}
                                    <span
                                    style={{marginLeft: "400px"}}> {user.createdDate
                                    }  </span>
                                    <div style={{wordWrap: "break-word"}}>{user.comments}  </div>
                                </div>

                            </div>
                        ))}
                </CommentContainer>
            </div>
        </Fragment>

    )

})

